"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Integration = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preact = require("preact");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Integration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Integration, _Component);

  var _super = _createSuper(Integration);

  function Integration(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Integration);
    _this = _super.call(this, props, context);

    _this.setState({
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false
    });

    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActivePanel = _this.setActivePanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActiveTab = _this.setActiveTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeValidationErrorFromInputField = _this.removeValidationErrorFromInputField.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeUninstallModal = _this.closeUninstallModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.displayUnsavedChangedModal = _this.displayUnsavedChangedModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickUninstallButton = _this.onClickUninstallButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedPanel = _this.setSelectedPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFederatedSearchSettingChanged = _this.onFederatedSearchSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.isInputInvalid = _this.isInputInvalid.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Integration, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                window.addEventListener('beforeunload', function (e) {
                  return _this2.onUnload(e);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "setActivePanel",
    value: function setActivePanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      if (this.checkPanelHasUnsavedChanges()) {
        this.setState({
          showUnsavedChangesModal: true,
          selectedTab: selectedTab
        });
        return;
      }

      this.setState({
        activeTab: selectedTab,
        selectedTab: selectedTab
      });
    }
  }, {
    key: "removeValidationErrorFromInputField",
    value: function removeValidationErrorFromInputField(inputField) {
      var _this$state$errorFiel, _this$state$errorFiel2;

      if (((_this$state$errorFiel = this.state.errorFields) === null || _this$state$errorFiel === void 0 ? void 0 : _this$state$errorFiel.length) === 0) {
        return;
      }

      var fields = (_this$state$errorFiel2 = this.state.errorFields) === null || _this$state$errorFiel2 === void 0 ? void 0 : _this$state$errorFiel2.filter(function (value) {
        return value.field !== inputField;
      });
      this.setState({
        errorFields: fields
      });
    }
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      this.setState({
        messageType: undefined,
        errorFields: [],
        isSavingCredentials: true
      });
    }
  }, {
    key: "isInputInvalid",
    value: function isInputInvalid(validatedFields) {
      if (validatedFields.length !== 0) {
        this.setState({
          errorFields: validatedFields,
          isSavingCredentials: false
        });
        return true;
      }

      return false;
    }
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "setSelectedPanel",
    value: function setSelectedPanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "onFederatedSearchSettingChanged",
    value: function onFederatedSearchSettingChanged(value) {
      this.setState({
        isFederatedSearchActive: value,
        showFederatedSearchActionButtons: true
      });
    }
  }]);
  return Integration;
}(_preact.Component);

exports.Integration = Integration;